import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "EditSelectedBlockToolbarstyle__Container",
  componentId: "sc-g77qp9-0"
})(["position:sticky;display:flex;flex-direction:column;align-items:center;& >:not(:first-child){margin-top:", ";}"], getSpacing(2));
export { Container };